import Step1 from '@/Classes/FollowUp/FollowUpPatint';
import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      patient: new Step1.step1(
        '',
        '',
        null,
        null,
        null,
        null,
        '',
        null,
        null,
        '',
        '',
        '',
        '',
        null,
        null,
        null,
        null,
        null,
        null,
      ),
      isChildren: false,
      tempArriveToPatientTime: '',
      showArriveToPatientTime: false,
      tempDateOfOnset: '',
      showDateOfOnset: false,
    };
  },
  methods: {
    goToStep2: function () {
      if (!this.patient.arriveToPatientTime) {
        this.showErrorAlert('زمان رسیدن بر بالین بیمار نمی تواند خالی باشد');
        return;
      }
      if (!this.patient.chiefComplaintText || !this.patient.chiefComplaintText.replace(/\s/g, '').length) {
        this.showErrorAlert('شکایت نمی تواند خالی باشد');
        return;
      }
      if (this.patient.isUnknown == true) {
        if (!this.patient.clothesColorAndType) {
          this.showErrorAlert('نوع و رنگ لباس نمی تواند خالی باشد');
          return;
        }
        if (!this.patient.clothesColorAndType.replace(/\s/g, '').length) {
          this.showErrorAlert('نوع و رنگ لباس نمی تواند خالی باشد');
          return;
        }
        if (!this.patient.specialCharacteristic) {
          this.showErrorAlert('مشخصه خاص نمی تواند خالی باشد');
          return;
        }
        if (!this.patient.specialCharacteristic.replace(/\s/g, '').length) {
          this.showErrorAlert('مشخصه خاص نمی تواند خالی باشد');
          return;
        }
      } else {

        if (!this.patient.firstName) {
          this.showErrorAlert('نام نمی تواند خالی باشد');
          return;
        }
        if (!this.patient.firstName.replace(/\s/g, '').length) {
          this.showErrorAlert('نام نمی تواند خالی باشد');
          return;
        }
        if (!this.patient.lastName) {
          this.showErrorAlert('نام خانوادگی نمی تواند خالی باشد');
          return;
        }
        if (!this.patient.lastName.replace(/\s/g, '').length) {
          this.showErrorAlert('نام خانوادگی نمی تواند خالی باشد');
          return;
        }
        if (!this.patient.yearOfAge && !this.patient.monthOfAge) {
          this.showErrorAlert('حدود سن نمی تواند خالی باشد');
          return;
        }
        if (this.patient.nationality == null) {
          this.showErrorAlert('ملیت نمی تواند خالی باشد');
          return;
        }
        if (this.patient.gender == null) {
          this.showErrorAlert('جنسیت نمی تواند خالی باشد');
          return;
        }
      }
      this.patient.missionPhoneId = Number(this.missionPhoneId);
      if (this.patientId) {
        this.patient.patientId = Number(this.patientId);
      } else {
        this.patient.patientId = null;
      }
      this.$root.$refs.FollowUpPatient.patientAge = this.patient.yearOfAge;
      this.$root.$refs.FollowUpPatient.patientMonth = this.patient.monthOfAge;
      this.addPatientFunction(this.patient);
    },
    clearDateTime: function (type) {
      if (type == 'arriveToPatientTime') {
        this.showArriveToPatientTime = false;
        this.patient.arriveToPatientTime = '';
        this.tempArriveToPatientTime = '';
      } else if (type == 'dateOfOnset') {
        this.showDateOfOnset = false;
        this.patient.dateOfOnset = '';
        this.tempDateOfOnset = '';
      }
    },
    dateTimeChange: function (type) {
      if (type == 'arriveToPatientTime') {
        if (this.patient.arriveToPatientTime) {
          this.tempArriveToPatientTime = Vue.moment(this.patient.arriveToPatientTime).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'dateOfOnset') {
        if (this.patient.dateOfOnset) {
          this.tempDateOfOnset = Vue.moment(this.patient.dateOfOnset).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      }
    },
    patientAdded: function (data) {
      this.patientId = data.id;
      this.$root.$refs.FollowUpPatient.patientId = data.id;
      this.$root.$refs.FollowUpPatient.changeTab1Step(2, true);
    },
    setData: function (data) {
      this.patient.firstName = data.firstName ? data.firstName : '';
      this.patient.lastName = data.lastName ? data.lastName : '';
      this.patient.chiefComplaintText = data.chiefComplaintText ? data.chiefComplaintText : '';
      if (data.isUnknown == true) {
        this.patient.isUnknown = true;
      } else {
        this.patient.isUnknown = false;
      }
      if (data.yearOfAge != null) {
        this.patient.yearOfAge = data.yearOfAge;
      } else {
        this.patient.yearOfAge = null;
      }
      if (data.monthOfAge != null) {
        this.patient.monthOfAge = data.monthOfAge;
      } else {
        this.patient.monthOfAge = null;
      }

      if (data.ageTotalDays != null) {
        this.patient.ageTotalDays = data.ageTotalDays;
        this.isChildren = true
      } else {
        this.patient.ageTotalDays = null;
        this.isChildren = false

      }
      this.patient.birthDate = data.birthDate;
      this.patient.nationalCode = data.nationalCode ? data.nationalCode : '';
      this.patient.nationality = data.nationality ? data.nationality : null;
      this.patient.gender = data.gender ? data.gender : '';
      this.patient.clothesColorAndType = data.clothesColorAndType ? data.clothesColorAndType : '';
      this.patient.specialCharacteristic = data.specialCharacteristic
        ? data.specialCharacteristic
        : '';
      if (data.arriveToPatientTime) {
        this.patient.arriveToPatientTime = data.arriveToPatientTime;
        this.tempArriveToPatientTime = Vue.moment(data.arriveToPatientTime).format(
          'HH:mm:ss jYYYY-jMM-jDD',
        );
      } else {
        this.patient.arriveToPatientTime = '';
        this.tempArriveToPatientTime = '';
      }
      if (data.dateOfOnset) {
        this.patient.dateOfOnset = data.dateOfOnset;
        this.tempDateOfOnset = Vue.moment(data.dateOfOnset).format('HH:mm:ss jYYYY-jMM-jDD');
      } else {
        this.patient.dateOfOnset = '';
        this.tempDateOfOnset = '';
      }
      this.patient.chiefComplaintId = data.chiefComplaint ? data.chiefComplaint.id : null;
      this.patient.doctorConsultationTypeId = data.doctorConsultationType
        ? data.doctorConsultationType.id
        : null;
      this.patient.resuscitationTypeId = data.resuscitationType ? data.resuscitationType.id : null;
      this.patientId = data.id;
      this.patient.id = data.id;
    },
    backToFollowUpMission: function () {
      let id = this.missionPhoneId.toString();
      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr5r2Dfr7lyf8N').toString();
      this.$router.push({ name: 'followUpMission', params: { id: encryptId } });
    },
  },
};
